import { render, staticRenderFns } from "./RadioQuestion.vue?vue&type=template&id=6f0d0e1d&scoped=true&"
import script from "./RadioQuestion.vue?vue&type=script&lang=ts&"
export * from "./RadioQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d0e1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0d0e1d')) {
      api.createRecord('6f0d0e1d', component.options)
    } else {
      api.reload('6f0d0e1d', component.options)
    }
    module.hot.accept("./RadioQuestion.vue?vue&type=template&id=6f0d0e1d&scoped=true&", function () {
      api.rerender('6f0d0e1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/typesOfQuestion/RadioQuestion.vue"
export default component.exports